    
const ComponentSet = {
    'r-dialog'          : () => import('./components/MessageDialog.vue' ),
    'r-pagination'      : () => import('./components/Pagination.vue'    ),
    'r-main-menu'       : () => import('./components/MainMenu.vue'      ),
    'r-fast-link'       : () => import('./components/FastLink.vue'      ),
    'r-inner-fast-link' : () => import('./components/InnerFastLink.vue'),
    'r-news-link'       : () => import('./components/NewsLink.vue'      ),
    'r-research-link'   : () => import('./components/ResearchLink.vue'  ),
};

export default ComponentSet;
